import { render, staticRenderFns } from "./ProfilePersonalInfo.vue?vue&type=template&id=38d5371e"
import script from "./ProfilePersonalInfo.vue?vue&type=script&lang=js"
export * from "./ProfilePersonalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports